<script lang="ts" setup>
import { PhWarningCircle } from '@phosphor-icons/vue';
</script>
<template>
	<div class="h-[60vh] p-xl">
		<div
			class="gap-3xl flex flex-col items-center justify-center h-full text-center"
		>
			<div class="p-2xl rounded-xl border border-gray-200 shadow-xs">
				<PhWarningCircle class="text-gray-800 size-[28px]" />
			</div>

			<div class="gap-md flex flex-col">
				<span class="text-lg font-semibold text-gray-800">
					Oops! We couldn't find what you were looking for
				</span>
				<span class="text-sm text-gray-600">
					Don’t give up, try and modify your search!
				</span>
			</div>
		</div>
	</div>
</template>
